// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2XPKq","buttons":"RemoveExpirationActionButtons_buttons__H-0hG"};